// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { englishTranlation } from './shared/languages/en';
import { spanishTranslation } from './shared/languages/es';
import { getStoredAppLanguage } from './utils/getStoredAppLanguage';

const resources = {
    en: {
      translation: englishTranlation
    },
    es: {
      translation: spanishTranslation
    }
  };

const initialLng = getStoredAppLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
